import { message, Row } from "antd";
import { format } from "date-fns";
import { useQrScannerContext } from "pages/QRScan/Context";
import React, { useState } from "react";
import styled from "styled-components";
import redeem from "assets/redeemcheck.svg";
import StyledButton from "components/button/Button";
import { Link, useNavigate, useParams } from "react-router-dom";
import { redeemSocialService } from "services/citizen";
import { handleApiValidationErrors } from "utils/api";
import Swal from "sweetalert2";
import BackIcon from "assets/akap/back-icon.svg";

const Container = styled.div`
  padding-right: 4rem;
  padding-left: 3rem;
  padding-top: 3rem;
`;

const ProgramSection = styled(Row)`
  display: flex;
  justify-content: center;
  text-align: center;
  flex-direction: column;
`;

const AgencyNameAndProgramName = styled.h1`
  font-weight: bold;
  font-size: 32px;
  letter-spacing: 0.32px;
`;

const EligibleText = styled.p`
  text-align: center;
  color: #1cc360;
  margin-top: 3rem;
`;

const RedeemSection = styled(ProgramSection)`
  margin-top: 3rem;
  color: #868686;
  font-weight: 500
  font-size: 14px;
  flex-direction: column;
`;

const RedeemText = styled.h3`
  font-weight: 600;
  color: #1cc360;
  font-size: 20px;
  letter-spacing: 0.2px;
  margin-bottom: 8px;
`;

const RedeemIcon = styled.img`
  margin-bottom: 8px;
`;

const BackIconImage = styled.img`
  width: 29px;
  height: 29px;
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
`;

const RedeeemBtn = styled(StyledButton)`
  background-color: #1cc360;
  font-weight: 700
  font-size: 14px;
  color: #fff;
  letter-spacing: 0.14px;
  height: 43px;
  border: none;
  width: 250px;

  &:hover {
    background: #1cc360;
  }
`;

const BackButton = styled(StyledButton)`
  height: 43px;
  border-radius: 11px;
  background: rgba(217, 217, 217, 0.21);
  width: 250px;
  margin-top: 1rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: initial;
  }
  @media only screen and (min-width: 768px) {
    background: white;
    span {
      color: initial;
    }
  }
`;

const BtnsSection = styled(ProgramSection)`
  margin-top: 2rem;
  align-items: center;
`;

const Eligible = () => {
  const { id } = useParams();
  const { user: agencyUser } = useQrScannerContext();

  const [isRedeemed, setIsRedeemed] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const navigate = useNavigate();

  const handleOnClickRedeem = () => {
    const citizenProgram = agencyUser?.overrides?.citizen_program;

    if (citizenProgram) {
      redeemSocialService({
        citizen: id,
        agency_user: agencyUser?.id || null,
        agency: agencyUser?.agency?.id || null,
        overrides: citizenProgram?.overrides || {},
        program: citizenProgram.program.id,
        program_type: citizenProgram.program_type.id,
        proposed_amount: citizenProgram.proposed_amount,
      })
        .then(response => {
          if (response.ok) {
            setIsRedeemed(!isRedeemed);
          } else if (response.status === 400) {
            handleApiValidationErrors(response);
          }
        })
        .catch(() => {
          Swal.fire({
            title: "An Error Occured",
            text: "There was a problem redeeming this program. Try again later",
            icon: "error",
            confirmButtonText: "Back",
            width: "80%",
          }).then(res => {
            if (res.isConfirmed) {
              navigate("/scan");
            }
          });
        });
    } else {
      messageApi.error({
        key: "quickRedeem",
        content: "Citizen program data is missing",
        style: {
          fontWeight: 500,
        },
      });
      setTimeout(() => {
        navigate("/scan");
      }, 1500);
    }
  };

  return (
    <Container>
      {contextHolder}
      <ProgramSection>
        <AgencyNameAndProgramName>
          {agencyUser?.agency?.acronym} {agencyUser?.overrides?.citizen_program?.program?.name}
        </AgencyNameAndProgramName>
      </ProgramSection>

      {isRedeemed && (
        <RedeemSection>
          <RedeemIcon src={redeem} />
          <RedeemText>Redeemed</RedeemText>
          {format(new Date(), "MMMM dd, yyyy h:mm a")}
        </RedeemSection>
      )}

      {!isRedeemed && <EligibleText>This user is eligible for this program</EligibleText>}
      <BtnsSection>
        {!isRedeemed && <RedeeemBtn onClick={() => handleOnClickRedeem()}>Mark as Redeemed</RedeeemBtn>}
        <Link to={-1}>
          <BackButton>
            <BackIconImage src={BackIcon} alt="Back" />
            Back
          </BackButton>
        </Link>
      </BtnsSection>
    </Container>
  );
};

export default Eligible;
